module.exports = __webpack_public_path__ + "img/1_opacity.a38e437c.png";